<template>
    <div>
        <b-card>
            <div>
                <b-table id="intake-received-results" ref="intakeReceivedResults" striped hover borderless
                         selectable
                         select-mode="single"
                         tbody-tr-class="text-center"
                         head-variant="dark"
                         primary-key="order_id"
                         no-provider-paging
                         no-provider-sorting
                         no-provider-filtering
                         show-empty
                         :busy.sync="isBusy"
                         :fields="fields"
                         :items="getResults"
                         :per-page="perPage"
                         :current-page="currentPage"
                         :sort-by.sync="sortBy"
                         :sort-desc.sync="sortDesc"
                         @row-selected="onRowSelected">
                    <template v-slot:cell(name)="data">
                        {{ data.item.first_name }} {{ data.item.last_name}}
                    </template>
                    <template v-slot:table-busy>
                        <LoadingSpinner :busy="isBusy"/>
                    </template>
                </b-table>

                <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="intake-received-results"
                        align="center"
                        size="sm"
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
    import LoadingSpinner from '../../components/LoadingSpinner';
    export default {
        name: 'intake-received',
        components: {
            LoadingSpinner,
        },
        data() {
            return {
                perPage: 25,
                currentPage: 1,
                totalRows: 0,
                isBusy: false,
                sortBy: 'received_at',
                sortDesc: true,
                fields: [
                    {key: 'id', label: 'Order #', class: 'text-center', sortable: true},
                    {key: 'customer.id', label: 'Customer #', class: 'text-center', sortable: true},
                    {key: 'customer.full_name', label: 'Name', class: 'text-center', sortable: false},
                    {key: 'brand.name', label: 'Brand', class: 'text-center', sortable: true},
                    {key: 'received_at', class: 'text-center', sortable: true},
                    {key: 'packages_received_today_count', label: 'Received Packages', class: 'text-center', sortable: true},
                ],
            };
        },
        computed: {

        },
        methods: {
            onRowSelected(items) {
                //TODO: navigate to order
                this.$router.push({ path: '/kit/view/' + items[0].id });
            },
            getResults(ctx, callback) {
                this.$http.get('/orders/bystatus/received')
                    .then(response => {
                        callback(response.data.data);
                    });

                return null;
            },
        },
    };
</script>

<style scoped>

</style>
